import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-md-4 border d-flex flex-column justify-content-around gap-4 p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, " My Account Summary ", -1)
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-column justify-content-between gap-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, " Most Recent Contribution Received: ", -1)
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, " Current Principal Balance: ", -1)
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-stretch gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary w-100" }, "View My Beneficiaries")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary w-100" }, "Add New Beneficiary")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($props.summary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createVNode(_component_router_link, {
              to: { name: 'annuity-details', query: { fromDate: $props.summary.Annuity.LastContribution.FormattedDate } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.summary.Annuity.LastContribution.Amount) + " on " + _toDisplayString($props.summary.Annuity.LastContribution.FormattedDate), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_5, " Total Contributions received for " + _toDisplayString($setup.year) + " : ", 1),
            _createVNode(_component_router_link, {
              to: { name: 'annuity-details', query: { fromDate: $props.summary.FromDate, toDate: $props.summary.ToDate } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.summary.Annuity.Total), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            ($setup.accountBalance)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.accountBalance), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, " Loading... "))
          ])
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_9, " Loading... ")),
    _hoisted_10
  ]))
}